
import {
    getToken, setToken, removeToken,removeRule,setRule,
    getUsername, setUsername, removeUsername, getRule,
} from '@/utils/auth';
import { Login, QuickLogin, Logout, Register, LoginByTelephone } from '@/api/Login';
import { CheckCaptcha } from "../../api/Login";
import * as types from '../mutation-types';
import md5 from 'js-md5'


/* eslint-disable */
// initial state
const state = {
    username: getUsername(), // 昵称
    token: getToken(), // 登录token
    rule: getRule(),//平台规则
};

// getters
const getters = {
    username: state => state.username,
    token: state => state.token,
};

// mutations
const mutations = {
    [types.RECEIVE_ADMIN_NAME](state, userName) {
        state.username = userName;
        if (userName === '') {
            removeUsername();
        } else {
            setUsername(userName);
        }
    },
    [types.RECEIVE_ADMIN_TOKEN](state, token) {
        state.token = token;
        if (token === '') {
            removeToken();
        } else {
            setToken(token);
        }
    },
    [types.RECEIVE_RULE_READ](state, rule) {
        state.rule = rule;
        if (rule === '') {
            removeRule();
        } else {
            setRule(rule);
        }
    },

};

// actions
const actions = {
    // 用户登录
    Login({ commit }, userInfo) {
        const username = userInfo.memberInfo;
        const password = md5(userInfo.password).substr(8,16);
        const unionId = userInfo.unionId;
        const openId = userInfo.openId;
        // const unionId = this.$cookies.get('unionid');
        return new Promise((resolve, reject) => {
            Login(username, password, unionId, openId)
                .then((response) => {
                    if (response.code === types.API_CODE.OK) {
                        const data = response.data;
                        commit(types.RECEIVE_ADMIN_TOKEN, data.token);
                        commit(types.RECEIVE_RULE_READ, data.readed);
                        localStorage.setItem(types.RECEIVE_RULE_READ, data.readed);
                        // localStorage.setItem("firstLogin",'true');
                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    QuickLogin({ commit }, members) {
        const unionId = members.unionId;
        const openId = members.openId;
        return new Promise((resolve, reject) => {
            QuickLogin(unionId, openId)
                .then((response) => {
                    if (response.code === types.API_CODE.OK) {
                        const data = response.data;
                        commit(types.RECEIVE_ADMIN_TOKEN, data.token);
                        commit(types.RECEIVE_RULE_READ, data.readed);
                        localStorage.setItem(types.RECEIVE_RULE_READ, data.readed);
                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    LoginByTelephone({ commit }, registerForm) {
        const username = registerForm.mobile;
        const password2 = md5(registerForm.password).substr(8,16);
        const unionId = registerForm.unionId;
        const openId = registerForm.openId;

        return new Promise((resolve, reject) => {
            LoginByTelephone(username, password2, unionId, openId)
                .then((response) => {
                    if (response.code === types.API_CODE.OK) {
                        const data = response.data;
                        commit(types.RECEIVE_ADMIN_TOKEN, data.token);
                        commit(types.RECEIVE_RULE_READ, data.readed);
                        localStorage.setItem(types.RECEIVE_RULE_READ, data.readed);
                        resolve(response);
                    } else if (response.code === 20002) {
                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    //验证码认证
    VerifyCode({ commit }, verifyInfo) {
        return new Promise((resolve, reject) => {
            const mobile = verifyInfo.mobile;
            const verifyCode = verifyInfo.verifyCode;
            const memberId = verifyInfo.memberId;
            CheckCaptcha(memberId, mobile, verifyCode)
                .then((response) => {
                    if (response.code === types.API_CODE.OK) {
                        const data = response.data;
                        commit(types.RECEIVE_ADMIN_TOKEN, data.token);

                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    // 用户注册
    Registry({ commit }, userInfo) {
        const password = md5(userInfo.password).substr(8,16);
        const realName = userInfo.realName;
        const mobile = userInfo.mobile;
        const type = 0;
        const captcha = userInfo.verifyCode;
        return new Promise((resolve, reject) => {
            Register(mobile, password, password, realName, type, captcha)
                .then((response) => {
                    if (response.code === types.API_CODE.OK) {
                        // const data = response.data;
                        // commit(types.RECEIVE_ADMIN_TOKEN, data.token);
                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    // 微信注册
    WeChatRegistry({ commit }, userInfo) {
        const password = md5(userInfo.mobile).substr(8,16);
        const realName = userInfo.mobile;
        const mobile = userInfo.mobile;
        const type = 0;
        const captcha = userInfo.verifyCode;
        return new Promise((resolve, reject) => {
            Register(mobile, password, password, realName, type, captcha)
                .then((response) => {
                    if (response.code === types.API_CODE.OK) {
                        // const data = response.data;
                        // commit(types.RECEIVE_ADMIN_TOKEN, data.token);
                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    // 登出
    Logout({ commit }) {
        return new Promise((resolve) => {
            Logout(getters.token);
            commit(types.RECEIVE_ADMIN_TOKEN, '');
            commit(types.RECEIVE_RULE_READ, '');
            localStorage.setItem(types.RECEIVE_RULE_READ, '');
            resolve();
        });
    },
    // 前端 登出
    FedLogout({ commit }) {
        return new Promise((resolve) => {
            commit(types.RECEIVE_ADMIN_TOKEN, '');
            commit(types.RECEIVE_RULE_READ, '');
            localStorage.setItem(types.RECEIVE_RULE_READ, '');
            resolve();
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
